import Vue from 'vue';
import LottoEvent from '@core/models/lotto/LottoEvent';
import { Commit, ActionContext } from 'vuex';
import StoreUtil from '@app/store/StoreUtil';
import LottoService from '@core/services/lotto/LottoService';
import LottoStatistics from '@core/models/lotto/LottoStatistics';

export const SET_LOTTO_EVENTS = 'SET_LOTTO_EVENTS';
const SET_LOTTO_EVENT = 'SET_LOTTO_EVENT';
const SET_GAME_STATISTICS = 'SET_GAME_STATISTICS';
const SET_IS_INITIAL_FETCH_FINISHED = 'SET_IS_INITIAL_FETCH_FINISHED';

export interface ILottoOfferState {
    lottoEvents: Record<number, LottoEvent>;
    lottoGameStatistics: Record<number, LottoStatistics>;
    isInitialFetchFinished: boolean;
}

const defaultState = (): ILottoOfferState => {
    return {
        lottoEvents: {},
        lottoGameStatistics: {},
        isInitialFetchFinished: false,
    };
};

export default function getLottoModule(options: any = {}) {

    const defaults = { ...defaultState(), ...options };

    return {
        namespaced: true,

        state: defaults,

        mutations: {
            [SET_LOTTO_EVENTS]: (state: ILottoOfferState, events: LottoEvent[]) => {
                state.lottoEvents = {};
                events.forEach((event) => Vue.set(state.lottoEvents as any, event.id, event));
            },
            [SET_LOTTO_EVENT]: (state: ILottoOfferState, event: LottoEvent) => {
                Vue.set(state.lottoEvents as any, event.id, event);
            },
            [SET_GAME_STATISTICS]: (state: ILottoOfferState, event: LottoEvent) => {
                Vue.set(state.lottoGameStatistics as any, event.lottoId, event.stats!.statistics);
            },
            [SET_IS_INITIAL_FETCH_FINISHED]: StoreUtil.createSimpleMutator('isInitialFetchFinished')
        },

        actions: {
            fetchLottoEvents: StoreUtil.asyncErrorGuard(async(
                { commit }: {commit: Commit },
                timeSpan: { startDate: Date, endDate: Date }) => {
                const { startDate, endDate } = timeSpan;
                const lottoEvents = await LottoService.getInstance().getLottoOffer(startDate, endDate);
                commit(SET_LOTTO_EVENTS, lottoEvents);
                commit(SET_IS_INITIAL_FETCH_FINISHED, true);
            }),
            fetchDetailedEvent: StoreUtil.asyncErrorGuard(async({ commit }: {commit: Commit }, id: number) => {
                const detailedEvents = await LottoService.getInstance().getLottoEventDetails([id]);
                // game statistics is the same for every event with same lotto id so it can be shared
                // every event has different result, important for results page!
                commit(SET_GAME_STATISTICS, detailedEvents[0]);
                commit(SET_LOTTO_EVENT, detailedEvents[0]);
            }),
        },

        getters: {
            lottoEventsMap: StoreUtil.createSimpleGetter('lottoEvents'),
            lottoEvents: (state: ILottoOfferState) => Object.values(state.lottoEvents),
            getLottoEvent: (state: ILottoOfferState) => ((eventId: number) => state.lottoEvents[eventId]),
            lottoGameStatistics: StoreUtil.createSimpleGetter('lottoGameStatistics'),
            isInitialFetchFinished: StoreUtil.createSimpleGetter('isInitialFetchFinished'),
        }
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/data/lottoOffer/lottoIndex.ts